
var vskoCard = angular.module('vskoCard', []);
vskoCard.directive('vskoCard', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-card.html'),
    replace: false,
    transclude: true,
    scope: {
    },
    link: function ($scope, element, attrs) {
      'use strict';
    }
  }
}]).directive('vskoCardLine', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-card-line.html'),
    replace: false,
    transclude: true,
    scope: {
       muted: '=',
       big: '=',
       baseline: '='
    },
    link: function ($scope, element, attrs) {
      'use strict';
       $scope.getStyleClass = function() {
        var styles = [];

        if ($scope.muted) {
          styles.push("bc-card-line-muted");
        }

        if ($scope.big) {
          styles.push("bc-card-line-big");
        }

        if ($scope.baseline) {
          styles.push("bc-card-line-position-bl");
        }
        return styles.join(" ");
      }
    }
  }
}]);
  